import * as React from 'react';
export const firsthawaiianSvg = React.forwardRef(function firsthawaiianSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#B41F28',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M18.805 12.585c-4.67 0-8.451 3.79-8.451 8.46h5.117c0-2.966 2.312-5.673 5.933-5.673 3.128 0 5.53 2.545 5.53 5.673h.313c0-4.67-3.782-8.46-8.451-8.46h.009Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16 9C9.368 9 4 14.386 4 21.036h5.682c0-5.028 4.06-9.097 9.07-9.097 5.009 0 8.934 4.078 8.934 9.097H28C28 14.386 22.623 9 15.991 9H16Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M21.323 16.008c-2.859 0-5.18 2.25-5.18 5.028h.314a2.444 2.444 0 0 1 2.446-2.447 2.444 2.444 0 0 1 2.447 2.447h5.144c0-2.778-2.321-5.028-5.18-5.028h.01Z',
      fill: '#fff',
    }),
  );
});
firsthawaiianSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var firsthawaiian = {
  category: 'brand',
  colorable: false,
  name: 'firsthawaiian',
  svg: firsthawaiianSvg,
};
